import { render, staticRenderFns } from "./Licitacoes.vue?vue&type=template&id=13eca62c&"
import script from "./Licitacoes.vue?vue&type=script&lang=js&"
export * from "./Licitacoes.vue?vue&type=script&lang=js&"
import style0 from "./Licitacoes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports